export const BETA_FEATURE_WHATSAPP = 'tracking_messages_whatsapp'
export const BETA_FEATURE_360_DIALOG = 'tracking_messages_whatsapp_360dialog'
export const TRUSTPILOT_VERIFIED_REVIEW = 'trustpilot_verified_review'
export const BETA_FEATURE_ALL_SETTINGS_BY_BRAND = 'tracking_messages_all_settings_by_brand'
